// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1mCFP","title":"ClientInsurance_title__2tTfX","itemText":"ClientInsurance_itemText__3S5Yy"};